// extracted by mini-css-extract-plugin
export default {"fin":"nabar_fin__kEazd","mai":"nabar_mai__5RmIs","main":"nabar_main__A64Tj","kl":"nabar_kl__av1ws"};